import './curator_list_component.scss'

import { Controller } from 'stimulus'

export default class extends Controller {
  stickToBottom () {
    this.element.style.position = 'absolute'
    this.element.style.bottom = '0'
  }

  resetPosition () {
    this.element.style.position = 'initial'
    this.element.style.bottom = 'initial'
  }

  get height () {
    return this.element.offsetHeight
  }
}
